module.exports = __webpack_public_path__ + "images/ebdb09f78dc836bf77b2dcea1b9713a1.svg";